__turbopack_context__.v({
  "button": "theme-module-scss-module__HJO-Ba__button",
  "buttonGroup": "theme-module-scss-module__HJO-Ba__buttonGroup",
  "card": "theme-module-scss-module__HJO-Ba__card",
  "groupLabel": "theme-module-scss-module__HJO-Ba__groupLabel",
  "input": "theme-module-scss-module__HJO-Ba__input",
  "inputWrapper": "theme-module-scss-module__HJO-Ba__inputWrapper",
  "link": "theme-module-scss-module__HJO-Ba__link",
  "option": "theme-module-scss-module__HJO-Ba__option",
  "pillsInput": "theme-module-scss-module__HJO-Ba__pillsInput",
});
